"use strict";
// Styles for use in the lineage/metadata info pane.
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var widgets_1 = require("@tableau/widgets");
var LayoutComponents_1 = require("../style/LayoutComponents");
var StyleConstants_1 = require("../style/StyleConstants");
var StyleFunctions_1 = require("../style/StyleFunctions");
var Colors = widgets_1.TabStyles.Colors;
var Spacing = widgets_1.TabStyles.Spacing;
var Sizing = widgets_1.TabStyles.Sizing;
var Typography = widgets_1.TabStyles.Typography;
var lineagePanelContainerStyles = {
    position: 'absolute',
    top: '0px',
    bottom: '0px',
    left: '0px',
    right: '0px',
    borderLeftStyle: 'solid',
    borderLeftWidth: Sizing.BorderWidth,
    borderLeftColor: Colors.L6,
    backgroundColor: Colors.White,
    color: Typography.Color.Primary,
    $nest: {
        'a': {
            textDecoration: 'none',
            color: StyleConstants_1.LinkBlue,
            $nest: {
                '&:hover': {
                    textDecoration: 'underline',
                }
            }
        }
    }
};
exports.LineagePanelContainer = LayoutComponents_1.divWithStyle('lineagePanel', lineagePanelContainerStyles);
exports.LoadingErrorMessage = LayoutComponents_1.divWithStyle('loadingErrorMessage', {
    marginTop: widgets_1.TabStyles.Spacing.LargeSpace,
    marginBottom: widgets_1.TabStyles.Spacing.MediumSpace,
    color: Typography.Color.Primary,
    fontSize: Typography.Sizing.Default,
    whiteSpace: 'pre-line'
});
exports.LoadingErrorCode = LayoutComponents_1.divWithStyle('loadingErrorCode', {
    marginBottom: widgets_1.TabStyles.Spacing.ExtraLargeSpace,
    color: Typography.Color.Secondary,
    fontSize: Typography.Sizing.Small
});
// Note: This class is used by other components, so it maybe should be moved to a different file
exports.loadingIndicator = StyleFunctions_1.cssClass('loadingIndicator', {
    textAlign: 'center',
    margin: Spacing.ExtraLargeSpace,
    marginTop: '84px',
    // tslint:disable-next-line: deprecation
    fontFamily: Typography.FontFamily,
    color: Typography.Color.Primary
});
// Sizing constants are potentially undefined.
var TitleBarHeight = Sizing.RowHeight || 0;
var TitleBarPaddingTop = Spacing.SmallSpace || 0;
var TitleBarPaddingBottom = Spacing.SmallSpace || 0;
var TitleBarBorderBottomWidth = 1;
exports.TitleBarContainer = LayoutComponents_1.divWithStyle('titleBarContainer', {
    paddingTop: TitleBarPaddingTop,
    paddingBottom: TitleBarPaddingBottom,
    paddingLeft: Spacing.MediumSpace,
    paddingRight: Spacing.MediumSpace,
    height: TitleBarHeight,
    display: 'flex',
    justifyContent: 'space-between',
    // Common header styles
    borderBottomColor: Colors.F5,
    borderBottomStyle: 'solid',
    borderBottomWidth: TitleBarBorderBottomWidth,
    backgroundColor: Colors.F1
});
exports.TitleTextCssClass = StyleFunctions_1.cssClass('titleText', {
    paddingLeft: Spacing.DefaultSpace,
    alignSelf: 'center',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    fontSize: Typography.Sizing.Default,
    fontWeight: 'normal',
    marginBottom: '0px',
    marginRight: 'auto',
    marginTop: '0px'
});
// Note: This class is used by other components, so it maybe should be moved to a different file
var lineagePanelBodyStyles = {
    paddingLeft: Spacing.LargeSpace,
    paddingRight: Spacing.LargeSpace,
    paddingTop: Spacing.LargeSpace,
    userSelect: 'text',
    '-webkit-user-select': 'text',
    '-moz-user-select': 'text',
    // Typestyle doesn't recognize the Opera vendor prefix and we don't officially support Opera anyway
    // '-o-user-select': 'text',
    '-ms-user-select': 'text',
    lineHeight: 1.5,
    position: 'absolute',
    top: TitleBarHeight + TitleBarPaddingTop + TitleBarPaddingBottom + TitleBarBorderBottomWidth,
    bottom: 0,
    left: 0,
    right: 0,
    overflowX: 'hidden'
};
exports.lineagePanelBody = StyleFunctions_1.cssClass('lineagePanelBody', lineagePanelBodyStyles);
exports.lineagePanelBodyWithError = StyleFunctions_1.cssClass('lineagePanelBodyWithError', __assign({}, lineagePanelBodyStyles, { 
    // Special one-off top margin per UX design
    marginTop: '100px', textAlign: 'center' }));
exports.HeaderDetailsContainer = LayoutComponents_1.divWithStyle('headerDetails', {
    display: 'flex',
    paddingBottom: Spacing.ExtraLargeSpace
});
// Used for headers in the viewer pane at a primary level
exports.SheetNameHeader = LayoutComponents_1.divWithStyle('sheetNameHeader', {
    fontSize: Typography.Sizing.Large,
    color: Typography.Color.Primary,
    marginBottom: Spacing.MediumSpace
});
exports.SectionHeader = LayoutComponents_1.divWithStyle('sectionHeader', {
    color: Typography.Color.Primary,
    marginBottom: Spacing.MediumSpace,
}, { role: 'heading', 'aria-level': 4 });
exports.DatasourceListContainer = LayoutComponents_1.divWithStyle('DatasourceListContainer', {
    paddingBottom: Spacing.ExtraLargeSpace
});
exports.DatasourceListBody = LayoutComponents_1.divWithStyle('DatasourceListBody', {});
exports.DatasourceListBodyElement = LayoutComponents_1.divWithStyle('DatasourceListBodyElement', {
    border: Sizing.BorderWidth + "px solid " + Colors.L6,
    padding: Spacing.DefaultSpace,
    marginBottom: Spacing.DefaultSpace,
});
exports.DatasourceIconNameContainer = LayoutComponents_1.divWithStyle('DatasourceIconNameContainer', {
    paddingTop: Spacing.DefaultSpace,
    paddingBottom: Spacing.DefaultSpace,
    paddingLeft: Spacing.MediumSpace
});
exports.DataQualityWarningContainer = LayoutComponents_1.divWithStyle('DataQualityWarningContainer', {});
exports.DataQualityWarningHeadlineContainer = LayoutComponents_1.divWithStyle('DataQualityWarningHeadlineContainer', {
    paddingTop: Spacing.DefaultSpace,
    paddingBottom: Spacing.DefaultSpace,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
});
exports.DataQualityWarningIcon = LayoutComponents_1.divWithStyle('DataQualityWarningIcon', {
    display: 'flex',
    paddingLeft: Spacing.DefaultSpace,
    paddingRight: Spacing.DefaultSpace,
});
exports.DataQualityWarningHeadline = LayoutComponents_1.divWithStyle('DataQualityWarningHeadline', {
    display: 'flex',
    flex: '1',
    verticalAlign: 'middle',
});
exports.DataQualityWarningByline = LayoutComponents_1.divWithStyle('DataQualityWarningByline', {
    color: Typography.Color.Secondary,
    fontSize: Typography.Sizing.Small,
});
exports.DataQualityWarningMessage = LayoutComponents_1.divWithStyle('DataQualityWarningMessage', {
    paddingTop: Spacing.DefaultSpace,
    paddingBottom: Spacing.DefaultSpace
});
exports.SheetFieldsListBody = LayoutComponents_1.divWithStyle('SheetFieldsListBody', {});
exports.SheetFieldListElementContainer = LayoutComponents_1.divWithStyle('SheetFieldListElementContainer', {
    paddingLeft: Spacing.MediumSpace,
    paddingBottom: Spacing.SmallSpace,
});
exports.DetailsPaneSection = LayoutComponents_1.divWithStyle('DetailsPaneSection', {
    flex: 'none',
    width: 300,
    display: 'flex',
    flexDirection: 'column',
    paddingBottom: Spacing.ExtraLargeSpace,
});
// Note: This class is used by other components, so it maybe should be moved to a different file
exports.LineageContainer = LayoutComponents_1.divWithStyle('LineageContainer', {
    flex: 'none',
    width: 300,
    display: 'flex',
    flexDirection: 'column',
    fontSize: Typography.Sizing.Default,
});
exports.DatasourceListSection = LayoutComponents_1.divWithStyle('DatasourceListSection', {
    flex: 'none',
    display: 'flex',
    flexDirection: 'column',
    paddingTop: Spacing.MediumSpace,
    paddingBottom: Spacing.ExtraLargeSpace,
});
// Note: This class is used by other components, so it maybe should be moved to a different file
exports.lineageNavCssClass = StyleFunctions_1.cssClass('LineageNav', {
    borderLeft: Sizing.BorderWidth + "px solid " + Colors.L6,
    padding: Spacing.DefaultSpace + "px " + Spacing.MediumSpace + "px"
});
// Note: This class is used by other components, so it maybe should be moved to a different file
exports.LineageNavHeader = LayoutComponents_1.divWithStyle('LineageNavHeader', {
    fontSize: Typography.Sizing.XLarge,
    padding: Spacing.DefaultSpace,
    paddingBottom: Spacing.ExtraLargeSpace
});
// Note: This class is used by other components, so it maybe should be moved to a different file
exports.lineageNavFilterIndicatorHeight = 20;
// Note: This class is used by other components, so it maybe should be moved to a different file
exports.lineageHeaderClass = StyleFunctions_1.cssClass('lineageHeaderClass', {
    justifyContent: 'space-between',
    height: exports.lineageNavFilterIndicatorHeight + 'px',
    lineHeight: exports.lineageNavFilterIndicatorHeight + 'px',
});
//# sourceMappingURL=ViewerPaneStyles.js.map